import React from "react";
import styles from "./ConflictItem.module.scss";

interface ConflictItemProps {
  field: { type: string; label: string; name: string };
  yourValue: string;
  theirValue: string;
  onSelect: (value: string) => void;
  TheirValueElement: React.ReactNode;
  YourValueElement: React.ReactNode;
}

export const ConflictItem: React.FC<ConflictItemProps> = ({
  field,
  yourValue,
  theirValue,
  onSelect,
  TheirValueElement,
  YourValueElement,
}) => {
  const { label, name } = field;

  return (
    <div className={styles.container}>
      <h4 className={styles.title}>{label} field:</h4>
      <div className={styles.row}>
        <div className={styles.column}>
          <label className={styles.radioLabel} htmlFor={name}>
            Your Value
          </label>
          <div className={styles.valueDiv}>
            <input
              type="radio"
              name={name}
              value={yourValue || ""}
              onChange={() => {
                onSelect(yourValue);
              }}
            />
            <div className={styles.conflictItem}>{YourValueElement}</div>
          </div>
        </div>

        <div className={styles.column}>
          <label className={styles.radioLabel} htmlFor={name}>
            Their Value
          </label>
          <div className={styles.valueDiv}>
            <input
              type="radio"
              name={name}
              value={theirValue || ""}
              onChange={() => onSelect(theirValue)}
            />
            <div className={styles.conflictItem}>{TheirValueElement}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
